<script lang="ts">
	// Stores
	import { devices_settings, devices_status } from 'src/stores';
	// Services and configs
	import { devices_config } from 'src/configs/devices';
	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	// Components
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];

	$: status = $devices_status[real_id(device?.id)];
	$: settings = $devices_settings[real_id(device?.id)];

	$: _statusesRaw =
		status?.online && deviceConfig ? status_configurator(status, device, settings) : null;
	$: _statuses = (Array.isArray(_statusesRaw) ? _statusesRaw : []) as any[];
	$: labelList = _statuses.filter((e) => {
		return 'undefined' === typeof e.main && e.name !== 'state';
	});
	$: hasLabels = status?.online && labelList.length > 0;
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		{#if hasLabels}
			<DeviceLabelList {labelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div slot="content"></div>
</DeviceViewStateWrapper>
